export default "__VITE_ASSET__DH3TdqAp__"